import React from "react";
import styles from "./ImageAudio.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVolumeUp, faPause } from "@fortawesome/free-solid-svg-icons";
import LessonInstruction from "../../containers/instruction/LessonInstruction";
import NoContentLesson from "../../components/NoContentLesson/NoContentLesson";
import useAudioPlayback from "../../hooks/useAudioPlayback";

const ImageAudio = ({ blockData, contentIndex, audioUrl }) => {

  const { state, togglePlayback} = useAudioPlayback(audioUrl, "image_audio");

  const getImageUrl = () => {
    let image = "";
    if (
      blockData &&
      blockData.complement &&
      blockData.complement.img &&
      blockData.complement.img.img
    ) {
      image = blockData.complement.img.img;
    }
    return process.env.REACT_APP_CLOUDFRONT_DNS + "/media/images/" + image;
  };

  const handlePlayPause = () => {
    togglePlayback();
  };

  if (!blockData || !blockData.content || blockData.content.length <= 0) {
    return <NoContentLesson />;
  }

  return (
    <div className={styles.default_card}>
      {blockData.content.length > 0 && blockData.content[contentIndex].type === "instruction" ? (
        <LessonInstruction instructionText={blockData.content[contentIndex].instruction} audioUrl={audioUrl} />
      ) : (
        <>
          <div className={styles.image_container}>
            <img alt="Audio" className={styles.image} src={getImageUrl()} />
          </div>
          <div className={styles.image_audio_container + " title-container"}>
            <div className={styles.audio_container} onClick={handlePlayPause}>
              <div className={styles.audio_icon_container}>
                {state === 'playing' ? (
                  <FontAwesomeIcon className={styles.audio_icon} size={"2x"} icon={faPause} />
                ) : (
                  <FontAwesomeIcon className={styles.audio_icon} size={"2x"} icon={faVolumeUp} />
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ImageAudio;
